import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import CustomButton from '../../../../components/buttons/CustomButton';
import styles from './TemplateDownload.module.css';

const TemplateDownload = () => {
    const handleDownload = () => {
        // URL do template já existente
        const templateUrl = '/data/template_import_patients.xlsx';
        
        // Criar um link temporário para download
        const link = document.createElement('a');
        link.href = templateUrl;
        link.download = 'template_import_patients.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Paper elevation={1} className={styles.container}>
            <Box className={styles.contentWrapper}>
                <div className={styles.iconSection}>
                    <div className={styles.iconContainer}>
                        <DescriptionOutlinedIcon className={styles.templateIcon} />
                    </div>
                </div>
                
                <div className={styles.textSection}>
                    <Typography variant="h6" className={styles.title}>
                        Baixe o modelo de planilha
                    </Typography>
                    
                    <Typography variant="body1" className={styles.description}>
                        Clique no botão abaixo para baixar o modelo de planilha que deve ser preenchido com os dados dos pacientes.
                    </Typography>
                    
                    <div className={styles.buttonContainer}>
                        <CustomButton
                            style="primary"
                            variant="contained"
                            label="Baixar Modelo de Planilha"
                            icon={<FileDownloadOutlinedIcon />}
                            onClick={handleDownload}
                        />
                    </div>
                    
                    <Typography variant="caption" color="textSecondary" className={styles.fileInfo}>
                        Formato: Microsoft Excel (.xlsx) - Tamanho: ~15KB
                    </Typography>
                    
                    <div className={styles.emailInstructions}>
                        <EmailOutlinedIcon className={styles.emailIcon} />
                        <Typography variant="body2" className={styles.emailText}>
                            Após preencher a planilha, envie-a para o email <strong>suporte@gabriela.app.br</strong> com o assunto "Importação de Pacientes - [Nome da sua clínica]".
                        </Typography>
                    </div>
                </div>
                
                <div className={styles.decorationCircle}></div>
            </Box>
        </Paper>
    );
};

export default TemplateDownload;